import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=64fac43e&"
import script from "./DashboardGrid.vue?vue&type=script&lang=ts&"
export * from "./DashboardGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports